'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-color: ',
    ';\n  ',
    ' ',
    ';\n'
  ],
  [
    '\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-color: ',
    ';\n  ',
    ' ',
    ';\n'
  ]
)

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var image = function image(props) {
  return props.image ? { backgroundImage: 'url(' + props.image + ')' } : null
}

var height = function height(props) {
  return props.height ? { height: props.height } : null
}

var BackgroundImage = _Box2.default.extend(
  _templateObject,
  function(props) {
    return props.theme.colors.smoke
  },
  image,
  height
)

BackgroundImage.displayName = 'BackgroundImage'

BackgroundImage.propTypes = {
  /** background-image url */
  image: _propTypes2.default.string
}

BackgroundImage.defaultProps = {
  theme: _theme2.default
}

exports.default = BackgroundImage



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/BackgroundImage.js
// module id = 66
// module chunks = 35783957827783 114276838955818 214865505688126